var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20871 1L5.12001 1.10535C5.73321 1.12754 6.2774 1.51477 6.51241 2.09616L7.37323 4.2257C7.57359 4.72126 7.51967 5.28669 7.22953 5.73306L6.12664 7.42999C6.77962 8.36767 8.55574 10.5646 10.4364 11.8506L11.8387 10.9876C12.1951 10.7682 12.6218 10.7031 13.0251 10.8065L15.8128 11.5213C16.5543 11.7115 17.0539 12.4225 16.9953 13.2041L16.8164 15.5908C16.7535 16.4283 16.068 17.0855 15.2544 16.9909C4.51395 15.7421 -1.78445 0.999976 2.20871 1V1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.650e8252920dbb89dee05b7688f5f8d5.svg";
export { ForwardRef as ReactComponent };